import React from 'react';
import { Nav, NavDropdown } from 'react-bootstrap';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";

import accountIcon from './../../../assets/images/account_circle-24px.svg';
import './AccountDropdown.css';





export const AccountDropdownComp = (props) => {
  let history = useHistory();



  const handleSelect = (eventKey) => {
    switch (eventKey) {
      case "SIGN_OUT": 
      history.push("/sign-out");
        break;
      default:
        return true;
    }
  };

  return (
    <React.Fragment> 
      { props.isUserLoggedIn && 
        <Nav onSelect={handleSelect} className="account-dropdown">
          <NavDropdown title={<img src={accountIcon} className="account-icon" alt="account-icon"/>} id="nav-dropdown">
            <div className="d-flex flex-column mb-2">
              <div className="text-center">
                <img src={accountIcon} className="account-icon-large" alt="account-icon"/>
              </div>
              <div className="text-center font-weight-bold">{props.loggedInName}</div>
            </div>
            <NavDropdown.Divider />
            <NavDropdown.Item eventKey="4.1" href={process.env.REACT_APP_CAMBRIDGE_MYACCOUNT_URL} target="_blank">My Account</NavDropdown.Item>
            <NavDropdown.Item eventKey="SIGN_OUT">Sign Out</NavDropdown.Item>
          </NavDropdown>
        </Nav>
      }    
    </React.Fragment>
  );
}

const mapStateToProps = state => {
  return { 
    isUserLoggedIn: state.currentUser.isUserLoggedIn,
    UID: state.currentUser.UID || null,
    loggedInName: state.currentUser.loggedInName
   };
};



export default connect(
  mapStateToProps  
)(AccountDropdownComp);
